<template>
  <f7-page name="dashboard">
    <div v-if="!showLogin">
      <TabView class="monitoring-tabview">
        <TabPanel class="card">
          <template #header>
            <f7-icon icon="f7-icons icon-home custom-color"></f7-icon>
          </template>

          <f7-block class="left-panel p-mt-0"> 
            <div class="card margin-bottom">
              <div class="card-header size-16">{{ $t("HOME_MSG001") }}</div>
              <div class="card-content">
                <Listbox
                  class="asset-list-box"
                  :virtualScrollerOptions="{ itemSize: 185 }"
                  listStyle="height: calc(100vh - 250px)"
                  v-model="selectedAsset"
                  :options="assetList"
                  optionLabel="Name"
                  :filter="true"
                >
                  <template #option="slotProps">
                    <div
                      v-html="slotProps.option.Icon"
                      class="item-media"
                    ></div>
                    <div class="item-inner">
                      <div class="item-title-row">
                        <div class="item-title">
                          <i class="f7-icons size-16 icon-network state-1"></i
                          ><i class="f7-icons size-16 icon-connect state-1"></i>
                          <f7-icon
                            style="vertical-align: initial"
                            icon="f7-icons icon-ignition-power size-16  state-1"
                          >
                          </f7-icon>
                        </div>
                        <div class="item-after">
                          <a
                            href="#"
                            class="link ripple-color-red bigger-touch-area assetMenu text-color-dark"
                            aria-haspopup="true"
                            aria-controls="asset_menu"
                            @click="assetMenu($event)"
                            >
                            <Menu
                              ref="assetMenu"
                              id="asset_menu"
                              class="custom-menu"
                              :model="assetMenuItems"
                              :popup="true"
                            >
                              <template #item="{ item, props }">
                                <a class="p-menuitem-link" v-bind="props" @click="handleMenuClick(item, slotProps.option)">
                                  <span
                                    :class="`p-menuitem-icon f7-icons icon-${item.icon}`"
                                  ></span>
                                  <span class="ml-2 p-menuitem-text">{{
                                    item.label
                                  }}</span>
                                </a>
                              </template>
                            </Menu>

                            <i class="f7-icons icon-menu-asset size-18"></i>
                          </a>
                        </div>
                      </div>
                      <div
                        class="item-subtitle weight-500"
                        :title="slotProps.option.Name"
                      >
                        {{ slotProps.option.Name }}
                      </div>
                      <Divider />
                      <div v-if="slotProps.option.Address" class="item-text size-12">
                        <f7-icon
                          style="vertical-align: initial"
                          icon="f7-icons icon-location size-12  state-0"
                        >
                        </f7-icon>
                        
                        {{ slotProps.option.Address }}
                      </div>

                    <div  v-else>
                      <Skeleton class="p-mb-2"></Skeleton>
                      <Skeleton class="p-mb-2"></Skeleton>
                      <Skeleton class=""></Skeleton>
                    </div>
                      


                    </div>
                  </template>
                </Listbox>
              </div>
            </div>
          </f7-block>



<div class="asset-alarms-widget show elevation-6">

					<div class="row no-gap widget-list overflow-auto">
					
						
						
						<div class="col widget-item">
							<div class="item-header bg-color-darkgray color-lightray tooltip-init" data-tooltip="ACC ON">

								
									<i class="p-menuitem-icon f7-icons icon-playback"></i>
								
							</div>
							<div class="item-content color-lightray other" data-report-type="9" data-report-alert-type="">
								Mileage
							</div>
							<div class="item-content " data-report-type="9" data-report-alert-type="32768">
								234 km
							</div>
						</div>
							<div class="col widget-item">
							<div class="item-header bg-color-darkgray color-lightray tooltip-init" data-tooltip="Speed">

								
							<i class=" f7-icons">clock_fill</i>
								
							</div>
							<div class="item-content color-lightray other" data-report-type="9" data-report-alert-type="">
								Engine Hours
							</div>
							<div class="item-content " data-report-type="9" data-report-alert-type="32">
								211:11:34
							</div>
						</div>
						
						<div class="col widget-item">
							<div class="item-header bg-color-darkgray color-lightray tooltip-init" data-tooltip="Other">

							<i class=" f7-icons ">speedometer</i>
								
							</div>
							<div class="item-content color-lightray other" data-report-type="9" data-report-alert-type="">
								Speed
							</div>
							<div class="item-content other" data-report-type="9" data-report-alert-type="">
								23 km/h
							</div>
						</div>

					
						<div class="col widget-item">
							<div class="item-header bg-color-darkgray color-lightray tooltip-init" data-tooltip="Geofence In">

								
								
							<i class=" f7-icons">bolt_fill</i>
							</div>
							<div class="item-content color-lightray other" data-report-type="9" data-report-alert-type="">
								Voltage
							</div>
							<div class="item-content " data-report-type="9" data-report-alert-type="8">
								12.5V
							</div>
						</div>

            
						<div class="col widget-item">
							<div class="item-header bg-color-darkgray color-lightray tooltip-init" data-tooltip="ACC OFF">

								<i class="p-menuitem-icon f7-icons icon-geolock"></i>
								
							</div>
							<div class="item-content color-lightray other" data-report-type="9" data-report-alert-type="">
								Ignition
							</div>
							<div class="item-content " data-report-type="9" data-report-alert-type="65536">
								OFF
							</div>
						</div>
						
						
						<div class="col widget-item">
							<div class="item-header bg-color-darkgray color-lightray tooltip-init" data-tooltip="Geofence Out">

								<i class="p-menuitem-icon f7-icons icon-alarm"></i>
								
							</div>
							<div class="item-content color-lightray other" data-report-type="9" data-report-alert-type="">
								Input1
							</div>
							<div class="item-content " data-report-type="9" data-report-alert-type="16">
								OFF
							</div>
						</div>
						
						<div class="col widget-item">
							<div class="item-header bg-color-darkgray  color-lightray tooltip-init" data-tooltip="High Temp">

								<i class="p-menuitem-icon f7-icons icon-alarm"></i>
								
							</div>
							<div class="item-content color-lightray other" data-report-type="9" data-report-alert-type="">
								Input2
							</div>
							<div class="item-content " data-report-type="9" data-report-alert-type="4194304">
								OFF
							</div>
						</div>
						
						
						
					</div>
					<!--<div class="show-control bg-color-white">
						<i class="icon f7-icons text-color-black size-18">chevron_down</i>
					</div>-->
				</div>



          <a
            href="#"
            class="link address-search-button"
            aria-haspopup="true"
            aria-controls="overlay_menu"
          >
            <Menu
              id="overlay_menu"
              ref="profileMenu"
              :model="menuProfileItems"
              :popup="true"
            />
            <f7-icon  f7="search"></f7-icon>
          </a>  
          <a
            href="#"
            class="link tile-select-button"
            @click="tileMenu"
            aria-haspopup="true"
            aria-controls="overlay_menu"
          >
            <Menu
              id="overlay_menu"
              ref="tileMenu"
              :model="menuTileItems"
              :popup="true"
            />
            <f7-icon  f7="rectangle_fill_on_rectangle_fill"></f7-icon>
          </a>  
          <a
            href="#"
            class="link settings-select-button"
            @click="settingsMenu"
            aria-haspopup="true"
            aria-controls="overlay_menu"
          >
            <Menu
              id="overlay_menu"
              ref="settingsMenu"
              :model="menuSettingsItems"
              :popup="true"
            />
            <f7-icon  f7="gear_alt_fill"></f7-icon>
          </a>  
          

          <l-map
            ref="map"
            id="map"
            v-model="zoom"
            v-model:zoom="zoom"
            :center="center"
            class="map-wrapper"
            :zoom-animation="true"
            :options="{ zoomControl: false }"
            @ready="onMapReady"
          >
            <l-geosearch :options="geosearchOptions"></l-geosearch>

            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :subdomains="tileProvider.subdomains"
              layer-type="base"
            />

            <l-feature-group
              ref="markersFeatureGroup"
              v-if="posInfoAssets.length"
            >
              <l-marker
                v-for="asset in posInfoAssets"
                @click="selectedMarker(asset)"
                :key="asset.assetID"
                :lat-lng="[asset.lat, asset.lng]"
              >
                <l-icon
                  :icon-size="[40, 40]"
                  :icon-anchor="[20, 39]"
                  :icon-url="iconUrl"
                />

                <l-popup>
                  <Listbox :options="assetInfo" optionLabel="name">
                    <template #option="slotProps">
                      <div class="asset-info-item p-d-flex p-jc-between">
                        <div>
                          <i
                            style="color: #dddee1; margin-right: 10px"
                            :data-icon="slotProps.option.icon"
                            class="icon size-20"
                          ></i>

                          <span st yle="color: #9a9ba4">
                            {{ slotProps.option.name }}
                          </span>
                        </div>
                        <div style="max-width: 180px; text-align: right">
                          <span style="">{{ slotProps.option.data }}</span>
                        </div>
                      </div>
                    </template>
                  </Listbox>
                </l-popup>
                <l-tooltip>
                  {{ asset.name }}
                </l-tooltip>
              </l-marker>
            </l-feature-group>
          </l-map>
        </TabPanel>
        
        <TabPanel>
          <template #header>
            <i class="custom-color f7-icons">chart_bar_circle_fill</i>
          </template>

          <f7-block>
            <f7-row>
              <!--TOP USAGE TABLE-->
              <f7-col width="100" large="100">
                <!--<alarm-table />-->
              </f7-col>
            </f7-row>
          </f7-block>
        </TabPanel>
        <TabPanel>
          <template #header>
            <i class="custom-color f7-icons">smallcircle_circle_fill</i>
            <!--<f7-icon icon="f7-icons icon-menu-geofence custom-color"></f7-icon>-->
          </template>

          <f7-block>
            <f7-row>
              <!--TOP USAGE TABLE-->
              <f7-col width="100" large="100">
                <!--<alarm-table />-->
              </f7-col>
            </f7-row>
          </f7-block>
        </TabPanel>
      </TabView>


      <a
        href="#"
        class="link ripple-color-red bigger-touch-area menu-notifications custom-color"
        aria-haspopup="true"
        aria-controls="overlay_menu"
      >
        <Menu
          id="overlay_menu"
          ref="profileMenu"
          :model="menuProfileItems"
          :popup="true"
        />
        <i class="custom-color f7-icons">bell_fill</i>
      </a>  
      <a
        href="#"
        class="link ripple-color-red bigger-touch-area menu-profile custom-color"
        @click="profileMenu"
        aria-haspopup="true"
        aria-controls="overlay_menu"
      >
        <Menu
          id="overlay_menu"
          ref="profileMenu"
          :model="menuProfileItems"
          :popup="true"
        />
        <i class="f7-icons icon-profile size-18"></i>
      </a>
    </div>

    <!-- <a href="/customers/">cusotmers</a>-->
    <f7-block v-else>
      <f7-row>
        <Sidebar
          v-model:visible="showLogin"
          class="login"
          :baseZIndex="1000"
          position="bottom"
        >
        <div v-if="isLoading" class="overlay">
          <ProgressSpinner />
        </div>
          <div
            class="flex-direction-column p-d-flex justify-content-space-around"
          >
            <Toolbar class="navbar-login">
              <template #start>
                <img
                  width="160"
                  src="../static/images/logo-main.svg"
                  alt="Image Logo"

                />
              </template>

              <template #end>
                <div class="navbar-collapse collapse">
                  <ul class="navbar-nav px-3 ml-auto bg-white text-dark">
                    <li class="nav-item">
                      <a
                        class="nav-link py-3 text-dark external-link"
                        href="#"
                        @click="toActivation"
                       
                        ><b>Activation</b></a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        class="nav-link py-3 text-dark external-link"
                        href="#"
                        @click="toMobileApp"
                        ><b>Contact</b></a
                      >
                    </li>
                    <!-- https://activation.al3rt.gps-secure.co/ -->

                    <li class="nav-item">
                      <a
                        class="nav-link py-3 text-dark external-link"
                        href="#"
                        target="_blank"
                        ><b>Support</b></a
                      >
                    </li>
                  </ul>
                </div>
              </template>
            </Toolbar>

            <div class="layout-profile card ">
              <div
                class="block-title size-22 text-custom-color text-align-center "
              >
                Login to your account
              </div>
               
              <div class="login-form  p-fluid p-formgrid p-grid align-left">
                <div class="p-field p-col-12">
                  <InputText
                    id="username"
                    v-model="loginForm.username"
                    type="text"
                    placeholder="Account"
                  />
                </div>
                <div class="p-field p-col-12">
                  <InputText
                    id="password"
                    v-model="loginForm.password"
                    type="password"
                    placeholder="Password"
                  />
                </div>
                <div class="p-field p-col-12 text-align-right">
                  <a
                    href="https://cartrack.co/forgot/password/"
                    class="text-color-dark"
                    @click="forgotPassword"
                    >Forgot password?</a>
                </div>
                <div class="p-field p-col-12 align-right">
                  <Button
                    label="LOGIN"
                    @click="onLogin"
                    class="p-button-login mt-30 w-100 p-button-lg uppercase"
                  />
                </div>
              </div>
            </div>
          </div>
          
        </Sidebar>
      </f7-row>
    </f7-block>
   
  </f7-page>
  <profile-modal
    :temp="tempObj"
    v-model:isOpened="isProfileModalOpened"
  ></profile-modal>
  <password-modal
    :temp="tempObj"
    v-model:isOpened="isPasswordModalOpened"
  ></password-modal>
  <playback-run-modal
    :temp="tempObj"
    v-model:isOpened=isPlaybackRunModalOpened

  ></playback-run-modal>
 
</template>
<script>
import AlarmTable from "../components/dashboard/alarm-table";

import Menu from "primevue/menu";
//import {computed, onMounted, reactive, watch} from "vue";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Skeleton from 'primevue/skeleton';
import Divider from "primevue/divider";
import Listbox from "primevue/listbox";
import ProfileModal from "../components/dashboard/profile-modal.vue";
import PasswordModal from "../components/dashboard/password-modal.vue";
import PlaybackRunModal from "../components/dashboard/playback-run-modal.vue";
import {
  getParentUrl,
  isObjEmpty,
  setInStorage,
  getFromStorage,
  Protocol
} from "../js/helper";
//import {computed, onMounted, reactive, watch} from "vue";
import { useStore, mapGetters } from "vuex";
import { useI18n } from "vue-i18n";
import Sidebar from "primevue/sidebar";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";
import Image from "primevue/image";
import moment from "moment-mini";
import ProgressSpinner from "primevue/progressspinner";

import { GeoSearchControl, OpenStreetMapProvider } from 'leaflet-geosearch';
import 'leaflet-geosearch/dist/geosearch.css';

import parseAssetsLocationData from "../js/parse-assets-position-data";
import {
  LMap,
  LIcon,
  LTileLayer,
  LMarker,
  LControlLayers,
  LPopup,
} from "@vue-leaflet/vue-leaflet";

import { f7 } from "framework7-vue";

export default {
  name: "dashboard",
  components: {
    Sidebar,
    InputText,
    Button,
    ProgressSpinner,
    Toolbar,
    Image,
    Skeleton,
    ProfileModal,
    PasswordModal,
    PlaybackRunModal,
    LMap,
    LIcon,
    LTileLayer,
    LMarker,
    LControlLayers,
    Divider,
    LPopup,

    AlarmTable,

    Listbox,
    TabView,
    TabPanel,
    Menu,
  },

  data() {
    return {
      loginForm: {
        username: "",
        password: "",

        appKey: "oiltank.quikloc8.com", //localStorage.PUSH_APP_KEY,
        mobileToken: localStorage.PUSH_MOBILE_TOKEN,
        deviceToken: localStorage.PUSH_DEVICE_TOKEN,
        deviceType: "browser", //localStorage.DEVICE_TYPE,
      },
      geosearchOptions: {
        provider: new OpenStreetMapProvider(),
        style: 'bar', // або 'button' для кнопки пошуку
        autoClose: true,
        keepResult: true,
      },
      userInfo: {},
      showLogin: true,

      posInfoAssets: [],
      iconUrl: "./static/images/pin-red.svg",
      tileProviders: [
        {
          name: "Map",
          visible: true,
          url: "https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
        },
      ],

      assetMenuItems: [
        /*{
          icon: "edit",
          label: "Edit",
          command: () => {
            // f7.views.main.router.navigate({
            //   name: "asset-info",
            // });
          },
        },
        {
          icon: "alarm",
          label: "Alarm",
          // command: () => {
          //   f7.views.main.router.navigate({
          //     name: "asset-info",
          //   });
          // },
        },*/
        {
          icon: "edit",
          label: "Asset info",
          command: () => {
            f7.views.main.router.navigate({
              name: "asset-info",
            });
          },
        },
        {
          icon: "playback",
          label: "Playback",
          command: () => {
            

            this.tempObj = this.selectedAsset;

         

            this.isPlaybackRunModalOpened = true;
          },
        },
        /*{
          icon: "geolock",
          label: "Geolock",
          command: () => {
            // f7.views.main.router.navigate({
            //   name: "asset-playback",
            // });
          },
        },*/
      ],
      menuSettingsItems: [],
      menuTileItems: [],
      menuProfileItems: [],
      POSINFOASSETLIST: {},
      LatLngAsset: [],
      assetImg: "",
      map: null,
      zoom: 9,
      center: [42, 42],
      layoutMode: "overlay",
      isAssetTotalsLoaded: false,
      solutionStats: [],
      assetTotals: [],
      parentUrl: "",
      tempObj: {},
      isProfileModalOpened: false,
      isPasswordModalOpened: false,
      isPlaybackRunModalOpened: false,
      locationData: {},
      assetList: [],
      selectedAsset: null,
      assetInfo: [],
      isLoading: false
    };
  },

  computed: {
    ...mapGetters([
      "AllSolutionStats",
      "ActivatedPerDay",
      "UsageOverview",
      "AllSimsStates",
      "IS_ROOT",
      "info",
      "POSINFOASSETLIST"


    ]),
  },

  watch: {
   
    selectedAsset(asset) {
      //console.log("asset", asset);
      if (asset && !asset.lat && !asset.lng) {
        let positionAsset = this.posInfoAssets.find(
          (itm) => itm.imei === asset.IMEI
        );
        this.center = [positionAsset.lat + .49 , positionAsset.lng];
      }
    },

    UsageOverview(data) {
      this.assetTotals = [
        {
          name: this.$t("TOTAL_ASSETS_MSG000"),
          value: data.SESSION_DAY,
          bgColor: "bg-custom-color-6",
          numeralFormat: "",
          textColor: "text-color-white",
        },
        {
          name: this.$t("TOTAL_ASSETS_MSG001"),
          value: data.DATA_DAY,
          bgColor: "bg-custom-color-5",
          numeralFormat: "",
          textColor: "text-color-white",
        },
        {
          name: this.$t("TOTAL_ASSETS_MSG002"),
          value: 5458, //data.SMS_MO_DAY + data.SMS_MT_DAY,
          bgColor: "bg-custom-color-3",
          numeralFormat: "",
          textColor: "text-color-white",
        },
        {
          name: this.$t("TOTAL_ASSETS_MSG003"),
          value: data.ONLINE_DAY,
          bgColor: "bg-custom-color-13  ",
          numeralFormat: "",
          textColor: "",
        },
      ];

      this.isAssetTotalsLoaded = true;
    },
    AllSolutionStats(items) {
      //console.log(items)
      const onStock = {
        name: "OnStock",
        value: 0,
        valueSecond: 0,
        bgColor: "bg-custom-color-1",
      };
      const deActivated = {
        name: "DeActivated",
        value: 0,
        valueSecond: 0,
        bgColor: "bg-custom-color-1",
      };
      const protect = {
        name: "Protect",
        value: 0,
        valueSecond: 0,
        bgColor: "bg-custom-color-2",
      };
      const qProtect = {
        name: "QProtect",
        value: 0,
        valueSecond: 0,
        bgColor: "bg-custom-color-3",
      };
      const loc8 = {
        name: "Loc8",
        value: 0,
        valueSecond: 0,
        bgColor: "bg-custom-color-4",
      };
      const boatWatch = {
        name: "BoatWatch",
        value: 0,
        valueSecond: 0,
        bgColor: "bg-custom-color-8",
      };
      const track = {
        name: "Track",
        value: 0,
        valueSecond: 0,
        bgColor: "bg-custom-color-5",
      };
      const watch = {
        name: "Watch",
        value: 0,
        valueSecond: 0,
        bgColor: "bg-custom-color-6",
      };

      if (items && items.length) {
        for (const [key, value] of Object.entries(items)) {
          /*switch (value.SOLUTION){
              case 'Unknown': case 'NonActivated':                onStock.value += value.Numbers; break;
              case 'Protect': case 'WiTiProtect':                 protect.value += value.Numbers; break;
              case 'QProtect': case 'WiTiQProtect':               qProtect.value += value.Numbers; break;
              case 'Loc8': case 'Al3rtLoc8':                      loc8.value += value.Numbers; break;
              case 'Track': case 'WiTiTrack': case 'SmartTrack':  track.value += value.Numbers; break;
              case 'Boat_watch': case 'BoatWatch':                boatWatch.value += value.Numbers; break;
              case 'Watch':                                       watch.value += value.Numbers; break;
              case 'DeActivate':                                  deActivated.value += value.Numbers; break;
            }*/
          switch (value.SOLUTION) {
            case "Unknown":
            case "NonActivated":
              onStock.value += value.Numbers;
              break;
            case "Protect":
            case "WiTiProtect":
              protect.value += value.Numbers;
              break;
            case "Boat_watch":
            case "BoatWatch":
              boatWatch.value += value.Numbers;
              break;
            case "DeActivate":
              deActivated.value += value.Numbers;
              break;
            default:
              let solution = value.SOLUTION?.toLowerCase();
              if (solution.indexOf("protect") > -1)
                qProtect.value += value.Numbers;
              if (solution.indexOf("loc8") > -1) loc8.value += value.Numbers;
              if (solution.indexOf("track") > -1) track.value += value.Numbers;
              if (solution.indexOf("watch") > -1) watch.value += value.Numbers;
          }
        }
      }

      if (this.ActivatedPerDay && this.ActivatedPerDay.length) {
        for (const [key, value] of Object.entries(this.ActivatedPerDay)) {
          /*switch (value.Solution){
              case 'Unknown': case 'NonActivated':                onStock.valueSecond += value.Number; break;
              case 'Protect': case 'WiTiProtect':                 protect.valueSecond += value.Number; break;
              case 'QProtect': case 'WiTiQProtect':               qProtect.valueSecond += value.Number; break;
              case 'Loc8': case 'Al3rtLoc8':                      loc8.valueSecond += value.Number; break;
              case 'Track': case 'WiTiTrack': case 'SmartTrack':  track.valueSecond += value.Number; break;
              case 'Watch':                                       watch.valueSecond += value.Number; break;
              case 'Boat_watch': case 'BoatWatch':                boatWatch.valueSecond += value.Number; break;
              case 'DeActivate':                                  deActivated.valueSecond += value.Numbers; break;
            }*/
          switch (value.Solution) {
            case "Unknown":
            case "NonActivated":
              onStock.valueSecond += value.Number;
              break;
            case "Protect":
            case "WiTiProtect":
              protect.valueSecond += value.Number;
              break;
            case "Boat_watch":
            case "BoatWatch":
              boatWatch.valueSecond += value.Number;
              break;
            case "DeActivate":
              deActivated.valueSecond += value.Number;
              break;
            default:
              let solution = value.Solution?.toLowerCase();
              if (solution.indexOf("protect") > -1)
                qProtect.valueSecond += value.Number;
              if (solution.indexOf("loc8") > -1)
                loc8.valueSecond += value.Number;
              if (solution.indexOf("track") > -1)
                track.valueSecond += value.Number;
              if (solution.indexOf("watch") > -1)
                watch.valueSecond += value.Number;
          }
        }
      }

      this.solutionStats = [protect, qProtect, loc8, track, watch, boatWatch];
      this.isSolutionStatsLoaded = true;
    },
    UsageOverview(data) {
      this.simStats = [
        {
          name: this.$t("DATA_SESSIONS_MSG000"), //'Data Sessions',
          value: data.SESSION_DAY,
          bgColor: "bg-custom-color-9",
          numeralFormat: "",
        },
        {
          name: this.$t("DATA_SESSIONS_MSG001"), //'Data Usage',
          value: data.DATA_DAY,
          bgColor: "bg-custom-color-10",
          numeralFormat: "0.0 b",
        },
        {
          name: this.$t("DATA_SESSIONS_MSG002"), //'SMS Usage',
          value: data.SMS_MO_DAY + data.SMS_MT_DAY,
          bgColor: "bg-custom-color-11",
          numeralFormat: "",
        },
        {
          name: this.$t("DATA_SESSIONS_MSG003"), //'Online Numbers',
          value: data.ONLINE_DAY,
          bgColor: "bg-custom-color-12",
          numeralFormat: "",
        },
      ];

      this.isSimStatsLoaded = true;
    },
    AllSimsStates(items) {
      const onStock = {
        name: "On Stock",
        value: 0,
        bgColor: "bg-color-lightgray",
      };
      const testProductive = {
        name: "Test Productive",
        value: 0,
        bgColor: "bg-color-lightblue",
      };
      const productive = {
        name: "Productive",
        value: 0,
        bgColor: "bg-color-lightgreen",
      };
      const suspended = {
        name: "Suspended",
        value: 0,
        bgColor: "bg-color-lightorange",
      };
      const terminated = {
        name: "Terminated",
        value: 0,
        bgColor: "bg-color-lightred",
      };

      if (items && items.length) {
        for (const [key, value] of Object.entries(items)) {
          switch (value.SimStatus) {
            case "OnStock":
              onStock.value += value.NUMBERS;
              break;
            case "TestProductive":
              testProductive.value += value.NUMBERS;
              break;
            case "Productive":
              productive.value += value.NUMBERS;
              break;
            case "Suspended":
              suspended.value += value.NUMBERS;
              break;
            case "Deleted":
            case "Deleting":
              terminated.value += value.NUMBERS;
              break;
          }
        }
      }

      this.simStats2 = [
        onStock,
        testProductive,
        productive,
        suspended,
        terminated,
      ];
      this.isSimStatsLoaded2 = true;
    },
  },
  created() {
    let msg = {
      type: "reset_checkOperationTimeOut",
      payload: {},
    };
    window.parent.postMessage(msg, "*");
  },

  mounted() {
    let userInfo = getFromStorage("userInfo");
    let assets = getFromStorage("assetList");

    if (!isObjEmpty(userInfo) && !isObjEmpty(assets)) {

      this.showLogin = false;
      this.assetList = assets;

 
      this.getAssetListPosInfo(assets);
    }
    let parentUrl = getParentUrl();
    this.parentUrl = parentUrl ? parentUrl : "https://quiktrak.co/";

    let msg = {
      type: "remove_preLoad",
      payload: {},
    };

  
    this.menuSettingsItems = [
      {
        icon: "smallcircle_circle_fill",
        label: "Geofenсes",
        command: () => {
          //this.isProfileModalOpened = true;
        },
      },
    ];
    this.menuTileItems = [
      {
        icon: "pi pi-circle",
        label: "Standart Map",
        command: () => {
          //this.isProfileModalOpened = true;
        },
      },
      {
        icon: "pi pi-circle",
        label: "Satellite",
        command: () => {
          //this.isPasswordModalOpened = true;
        },
      },
      {
        icon: "pi pi-circle",
        label: "Open Street",
        command: () => {
          //this.isProfileModalOpened = true;
        },
      },
    ];

    this.menuProfileItems = [
      {
        icon: "pi pi-info-circle",
        label: "Profile",
        command: () => {
          this.isProfileModalOpened = true;
        },
      },
      {
        icon: "pi pi-lock",
        label: "Password",
        command: () => {
          this.isPasswordModalOpened = true;
        },
      },
      {
        icon: "pi pi-power-off",
        label: "Logout",
        command: () => {
          this.$store.dispatch("logout");
          localStorage.clear();
          this.showLogin = true;
        },
      },
    ];
    setTimeout(window.parent.postMessage(msg, "*"), 2000);


    console.log('POSINFOASSETLIST',this.POSINFOASSETLIST)

    this.$store.commit('SET_POSINFOASSETLIST', this.POSINFOASSETLIST);

    //console.log('reset timeout click')
    /*const { t } = useI18n()
      this.simStats = [
        {
          name: t('DATA_SESSIONS_MSG000'), //'Data Sessions',
          value: 150456,
          bgColor: 'bg-custom-color-3'
        },
        {
          name: t('DATA_SESSIONS_MSG001'), //'Data Usage',
          value: 567,
          bgColor: 'bg-custom-color-7'
        },
        {
          name: t('DATA_SESSIONS_MSG002'), //'SMS Usage',
          value: 34,
          bgColor: 'bg-custom-color-4'
        },
        {
          name: t('DATA_SESSIONS_MSG003'), //'Online Numbers',
          value: 432,
          bgColor: 'bg-custom-color-5'
        },
      ]*/
  },

  methods: {
    onMapReady(map) {
      const provider = new OpenStreetMapProvider();

      const searchControl = new GeoSearchControl({
        provider: provider,
        style: "bar",
        searchLabel: "Введіть адресу...",
        autoClose: true,
        keepResult: true,
        updateMap: true, // Важливо для оновлення карти
      });

      map.addControl(searchControl);
      /*provider.search({ query: "Київ, Україна" }).then((result) => {
        console.log(result);
      });*/
    },
    toMobileApp() {
      window.open("https://play.google.com/store/apps/details?id=com.dealersown.app", "_blank");
    },
    toActivation() {

      window.open("https://cartrack.co/activation/dealersown/", "_blank");
    },
    forgotPassword() {
      window.open("https://cartrack.co/forgot/password/", "_blank");
    },
    handleMenuClick(item, asset, event) {
   
      item.command();
      this.$refs.assetMenu.hide(event);
    },
    async selectedMarker(asset) {
      let lat = new String(asset.lat);

      let lng = new String(asset.lng);

      let positionAsset = this.assetList.find((itm) => itm.imei === asset.IMEI);

      console.log(positionAsset);

      this.assetInfo = [
        { name: "Name", data: asset.name, icon: "y" },
        {
          name: "Address",
          data: positionAsset.Address,
          icon: "l",
        },
        // {
        //   name: "Coordinates",
        //   data: lat.slice(0, 8) + ", " + lng.slice(0, 8),
        //   icon: "c",
        // },
        { name: "Voltage", data: "0 V", icon: "p" },
        // { name: "Current I", data: "0 A", icon: "d" },
        { name: "ACC", data: "Off", icon: "u" },
        { name: "GPS", data: "0", icon: "h" },
        { name: "Location",  data: lat.slice(0, 8) + ", " + lng.slice(0, 8), icon: "t" },
      ];
    },
    guid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (
        S4() +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        "-" +
        S4() +
        S4() +
        S4()
      );
    },

    getPlusInfo() {
      var self = this;

      var uid = self.guid();
      if (window.device) {
        if (!localStorage.PUSH_MOBILE_TOKEN) {
          localStorage.PUSH_MOBILE_TOKEN = uid;
        }
        localStorage.PUSH_APP_KEY = BuildInfo.packageName;
        localStorage.PUSH_APPID_ID = BuildInfo.packageName;
        localStorage.DEVICE_TYPE = device.platform;
      } else {
        if (!localStorage.PUSH_MOBILE_TOKEN)
          localStorage.PUSH_MOBILE_TOKEN = uid;
        if (!localStorage.PUSH_APP_KEY) localStorage.PUSH_APP_KEY = self.id;
        if (!localStorage.PUSH_DEVICE_TOKEN)
          localStorage.PUSH_DEVICE_TOKEN = uid;
        //localStorage.PUSH_DEVICE_TOKEN = "75ba1639-92ae-0c4c-d423-4fad1e48a49d"
        localStorage.PUSH_APPID_ID = self.id;
        localStorage.DEVICE_TYPE = "browser";
      }
    },
    setAssetList: function (params = {}) {
			
			var self = this;
			//console.log('userInfo',USERROLE) && USERROLE != 2 || USERROLE == 2
			var ret = '';
			//console.log(params.list)
			if (params.list && params.list.length) {
				var ary = {};
				for (var i = 0; i < params.list.length; i++) {
					var index = 0;
					if(params.list[i][48] === 'False'){
						//console.log('SEEEE')
					ary[params.list[i][1]] = {
						Id: params.list[i][index++],
						IMEI: params.list[i][index++],
						Name: params.list[i][index++],
						TagName: params.list[i][index++],
						Icon: params.list[i][index++],
						Unit: params.list[i][index++],
						InitMileage: params.list[i][index++],
						InitAcconHours: params.list[i][index++],
						State: params.list[i][index++],
						ActivateDate: params.list[i][index++],
						PayPlanName: params.list[i][index++],
						PRDTName: params.list[i][index++],
						PRDTFeatures: params.list[i][index++],
						PRDTAlerts: params.list[i][index++],
						Describe1: params.list[i][index++],
						Describe2: params.list[i][index++],
						Describe3: params.list[i][index++],
						Describe4: params.list[i][index++],
						Describe5: params.list[i][index++],
						_FIELD_FLOAT1: params.list[i][index++],
						_FIELD_FLOAT2: params.list[i][index++],
						_FIELD_FLOAT7: params.list[i][index++],
						Describe7: params.list[i][index++],
						AlarmOptions: params.list[i][index++],
						StatusNew: params.list[i][index++],
						_FIELD_FLOAT8: params.list[i][index++],
						IMSI: params.list[i][index++],
						_FIELD_INT2: params.list[i][index++],
						GroupCode: params.list[i][index++],
						SolutionType: params.list[i][index++],
						Registration: params.list[i][index++],
						StockNumber: params.list[i][index++],
						MaxSpeed: params.list[i][index++],
						MaxSpeedAlertMode: params.list[i][index++],
						DaysInInventory: moment.utc().diff(moment.utc(params.list[i][index], window.COM_TIMEFORMAT), 'days'),
						StorageTime: params.list[i][index++],
						ActivationTime: params.list[i][index++],
						BusinessExpense: params.list[i][index++],
						FuelEconomy: params.list[i][index++],
						EngineCapacity: params.list[i][index++],
						OffroadTaxCredit: params.list[i][index++],
						AssetType: params.list[i][index++],
						AlarmOptions2: params.list[i][index++],
						DriverCode: params.list[i][index++],
						RoadSpeed: params.list[i][index++],
						LBSWIFI: params.list[i][index++],
						STATICDRIFT: params.list[i][index++],
						Input1Name_: params.list[i][index++],
						Input2Name_: params.list[i][index++],
						isShared: (params.list[i][index++].toLowerCase() === "true"),
						SuspendDate: params.list[i][index++],
						undefined1: params.list[i][index++],
						undefined2: params.list[i][index++],
						undefined3: params.list[i][index++],
						Input1Type: params.list[i][index++], //ignore
						Input1Name: params.list[i][index++],
						Input1Mask: params.list[i][index++], //ignore
						Input1Icon: params.list[i][index++],
						Input2Type: params.list[i][index++], //ignore
						Input2Name: params.list[i][index++],
						Input2Mask: params.list[i][index++], //ignore
						Input2Icon: params.list[i][index++],
						Input3Type: params.list[i][index++], //ignore
						Input3Name: params.list[i][index++],
						Input3Mask: params.list[i][index++], //ignore
						Input3Icon: params.list[i][index++],
						Input4Type: params.list[i][index++], //ignore
						Input4Name: params.list[i][index++],
						Input4Mask: params.list[i][index++], //ignore
						Input4Icon: params.list[i][index++],
						Output1Type: params.list[i][index++], //ignore
						Output1Name: params.list[i][index++],
						Output1Mask: params.list[i][index++], //ignore
						Output1Icon: params.list[i][index++],
						Output2Type: params.list[i][index++], //ignore
						Output2Name: params.list[i][index++],
						Output2Mask: params.list[i][index++], //ignore
						Output2Icon: params.list[i][index++],
						SubscriptionId: params.list[i][index++], 
						undefined4: params.list[i][index++],
						LicenceDisk: params.list[i][index++],
						DiskExpiryDate: params.list[i][index++],
						undefined5: params.list[i][index++],
						undefined6: params.list[i][index++],
						undefined7: params.list[i][index++],
						iButtonFlag: params.list[i][index++],
						ActualAlarmNames: params.list[i][index++],
						Input1AcconHours: params.list[i][index++],
						Input2AcconHours: params.list[i][index++],
						//IsTcpImmobilise:  params.list[i][index++],
						IsLocalRenewal: params.list[i][index++],
					};
					/*if (POSINFOASSETLIST && POSINFOASSETLIST[params[i][1]]) {
								  POSINFOASSETLIST[params[i][1]].StatusNew =  ary[params[i][1]].StatusNew;
							  }  */
					}
				}
				ret = ary;
				localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.ASSETLIST", JSON.stringify(ary));	//~~~			
				// self.methods.setToLocalDB("COM.QUIKTRAK.QUIKLOC8.ASSETLIST", JSON.stringify(ary));
				/*$.ajax({
							type: "POST",								
							url: "../resources/php/set.php", 
							dataType: 'json',
							data: JSON.stringify({storage_name: "COM.QUIKTRAK.QUIKLOC8.ASSETLIST", storage_account: localStorage.ACCOUNT, storage_data: ary}), //JSON.stringify({storage_name, storage_data: storage_data, storage_account: localStorage.ACCOUNT}),
							async: true, 
							cache: false,
							beforeSend: function(){
								
							},	
							success: function(data){
								//console.log('set data to ' + storage_name)
							},
							error: function(XMLHttpRequest, textStatus, errorThrown){
								console.log(XMLHttpRequest);
								console.log(textStatus);
								console.log(errorThrown);								
							}													
						});*/

			} else if (params.device) {
				var list = self.methods.getFromStorage('assetList');

				if (POSINFOASSETLIST[params.device.IMEI]) {
					POSINFOASSETLIST[params.device.IMEI].Name = list[params.device.IMEI].Name = params.device.name;
					POSINFOASSETLIST[params.device.IMEI].TagName = list[params.device.IMEI].TagName = params.device.tag;
					POSINFOASSETLIST[params.device.IMEI].Registration = list[params.device.IMEI].Registration = params.device.registration;
					POSINFOASSETLIST[params.device.IMEI].Unit = list[params.device.IMEI].Unit = params.device.speedUnit;
					POSINFOASSETLIST[params.device.IMEI].InitMileage = list[params.device.IMEI].InitMileage = params.device.initMileage;
					POSINFOASSETLIST[params.device.IMEI].InitAcconHours = list[params.device.IMEI].InitAcconHours = params.device.initAccHours;
					POSINFOASSETLIST[params.device.IMEI].Describe1 = list[params.device.IMEI].Describe1 = params.device.attr1;
					POSINFOASSETLIST[params.device.IMEI].Describe2 = list[params.device.IMEI].Describe2 = params.device.attr2;
					POSINFOASSETLIST[params.device.IMEI].Describe3 = list[params.device.IMEI].Describe3 = params.device.attr3;
					POSINFOASSETLIST[params.device.IMEI].Describe4 = list[params.device.IMEI].Describe4 = params.device.attr4;
					POSINFOASSETLIST[params.device.IMEI].GroupCode = list[params.device.IMEI].GroupCode = params.device.groupCode;
					POSINFOASSETLIST[params.device.IMEI].DriverCode = list[params.device.IMEI].DriverCode = params.device.DriverCode;
					POSINFOASSETLIST[params.device.IMEI].RoadSpeed = list[params.device.IMEI].RoadSpeed = params.device.RoadSpeed;
					POSINFOASSETLIST[params.device.IMEI].LBSWIFI = list[params.device.IMEI].LBSWIFI = params.device.LBSWIFI;
					POSINFOASSETLIST[params.device.IMEI].STATICDRIFT = list[params.device.IMEI].STATICDRIFT = params.device.STATICDRIFT;
					POSINFOASSETLIST[params.device.IMEI].Input1Name = list[params.device.IMEI].Input1Name = params.device.Input1Name;
					POSINFOASSETLIST[params.device.IMEI].Input2Name = list[params.device.IMEI].Input2Name = params.device.Input2Name;
					POSINFOASSETLIST[params.device.IMEI].Input3Name = list[params.device.IMEI].Input3Name = params.device.Input3Name;
					POSINFOASSETLIST[params.device.IMEI].Input4Name = list[params.device.IMEI].Input4Name = params.device.Input4Name;
					POSINFOASSETLIST[params.device.IMEI].Output1Name = list[params.device.IMEI].Output1Name = params.device.Output1Name;
					POSINFOASSETLIST[params.device.IMEI].Output2Name = list[params.device.IMEI].Output2Name = params.device.Output2Name;

					if (params.device.stockNumber) {
						POSINFOASSETLIST[params.device.IMEI].StockNumber = list[params.device.IMEI].StockNumber = params.device.stockNumber;
					}
					if (params.device.icon) {
						POSINFOASSETLIST[params.device.IMEI].Icon = list[params.device.IMEI].Icon = params.device.icon + '?' + new Date().getTime();
					}
					if (params.device.MaxSpeed) {
						POSINFOASSETLIST[params.device.IMEI].MaxSpeed = list[params.device.IMEI].MaxSpeed = params.device.MaxSpeed;
					}
					if (params.device.BusinessExpense) {
						POSINFOASSETLIST[params.device.IMEI].BusinessExpense = list[params.device.IMEI].BusinessExpense = params.device.BusinessExpense;
					}
					if (params.device.FuelEconomy) {
						POSINFOASSETLIST[params.device.IMEI].FuelEconomy = list[params.device.IMEI].FuelEconomy = params.device.FuelEconomy;
					}
					if (params.device.EngineCapacity) {
						POSINFOASSETLIST[params.device.IMEI].EngineCapacity = list[params.device.IMEI].EngineCapacity = params.device.EngineCapacity;
					}
					if (params.device.OffroadTaxCredit) {
						POSINFOASSETLIST[params.device.IMEI].OffroadTaxCredit = list[params.device.IMEI].OffroadTaxCredit = params.device.OffroadTaxCredit;
					}
					if (params.device.AssetType) {
						POSINFOASSETLIST[params.device.IMEI].AssetType = list[params.device.IMEI].AssetType = params.device.AssetType;
					}

					if (params.device.IsLocalRenewal) {
						POSINFOASSETLIST[params.device.IMEI].IsLocalRenewal = list[params.device.IMEI].AssetType = params.device.IsLocalRenewal;
					}


				} else {
					list[params.device.IMEI].Name = params.device.name;
					list[params.device.IMEI].TagName = params.device.tag;
					list[params.device.IMEI].Registration = params.device.registration;
					list[params.device.IMEI].Unit = params.device.speedUnit;
					list[params.device.IMEI].InitMileage = params.device.initMileage;
					list[params.device.IMEI].InitAcconHours = params.device.initAccHours;
					list[params.device.IMEI].Describe1 = params.device.attr1;
					list[params.device.IMEI].Describe2 = params.device.attr2;
					list[params.device.IMEI].Describe3 = params.device.attr3;
					list[params.device.IMEI].Describe4 = params.device.attr4;
					list[params.device.IMEI].GroupCode = params.device.groupCode;
					list[params.device.IMEI].DriverCode = params.device.DriverCode;
					list[params.device.IMEI].RoadSpeed = params.device.RoadSpeed;
					list[params.device.IMEI].LBSWIFI = params.device.LBSWIFI;
					list[params.device.IMEI].STATICDRIFT = params.device.STATICDRIFT;
					list[params.device.IMEI].Input1Name = params.device.Input1Name;
					list[params.device.IMEI].Input2Name = params.device.Input2Name;
					list[params.device.IMEI].Input3Name = params.device.Input3Name;
					list[params.device.IMEI].Input4Name = params.device.Input4Name;
					list[params.device.IMEI].Output1Name = params.device.Output1Name;
					list[params.device.IMEI].Output2Name = params.device.Output2Name;

					if (params.device.stockNumber) {
						list[params.device.IMEI].StockNumber = params.device.stockNumber;
					}
					if (params.device.icon) {
						list[params.device.IMEI].Icon = params.device.icon + '?' + new Date().getTime();
					}
					if (params.device.MaxSpeed) {
						list[params.device.IMEI].MaxSpeed = params.device.MaxSpeed;
					}
					if (params.device.BusinessExpense) {
						list[params.device.IMEI].BusinessExpense = params.device.BusinessExpense;
					}
					if (params.device.FuelEconomy) {
						list[params.device.IMEI].FuelEconomy = params.device.FuelEconomy;
					}
					if (params.device.EngineCapacity) {
						list[params.device.IMEI].EngineCapacity = params.device.EngineCapacity;
					}
					if (params.device.OffroadTaxCredit) {
						list[params.device.IMEI].OffroadTaxCredit = params.device.OffroadTaxCredit;
					}
					if (params.device.AssetType) {
						list[params.device.IMEI].AssetType = params.device.AssetType;
					}
					if (params.device.IsLocalRenewal) {
						list[params.device.IMEI].IsLocalRenewal = params.device.IsLocalRenewal;
					}

				}

				localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.ASSETLIST", JSON.stringify(list));//~~~

				// self.methods.setToLocalDB("COM.QUIKTRAK.QUIKLOC8.ASSETLIST", JSON.stringify(list));
				/*}else if(params.devices){
						var list = self.methods.getFromStorage('assetList');
		
						for (var i = params.devices.length - 1; i >= 0; i--) {
							if (params.devices[i].IMEI && params.devices[i].Props) {
								let keys = Object.keys(params.devices[i].Props);
								for (const key of keys) {
									if (POSINFOASSETLIST[params.devices[i].IMEI][key]) {
										POSINFOASSETLIST[params.devices[i].IMEI][key] = list[params.devices[i].IMEI][key] = params.devices[i].Props[key];
									}else{
										list[params.devices[i].IMEI][key] = params.devices[i].Props[key];
									}
		
								}
							}
						}
		
						localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.ASSETLIST", JSON.stringify(list));*/

			} else if (params.objects) {
				localStorage.setItem("COM.QUIKTRAK.QUIKLOC8.ASSETLIST", JSON.stringify(params.objects));//~~~

				// self.methods.setToLocalDB("COM.QUIKTRAK.QUIKLOC8.ASSETLIST", JSON.stringify(params.objects));
			}

			//console.log(ary);
			return ret;
		},
    async getAssetListPosInfo(listObj, update) {
      let self = this;
      //  var userInfo = self.methods.getFromStorage('userInfo');
     // console.log('listObj', listObj)
 
      let codes = "";
      $.each(listObj, function (index, val) {
        codes += val.Id + ",";
      });
      if (codes) {
        codes = codes.slice(0, -1);
      }

      const codesObj = {
        codes: codes,
      };

      const userInfo = getFromStorage("userInfo");

      const query = {
        MajorToken: this.info.MajorToken
          ? this.info.MajorToken
          : userInfo.MajorToken,
        MinorToken: this.info.MinorToken
          ? this.info.MinorToken
          : userInfo.MinorToken,
        codes: codesObj,
      };

      let response = await this.$store.dispatch("GET_ASSETS_LOCATION", query);

      if (!response || !response.length) {
        return;
      } else {
        this.posInfoAssets = [
          ...parseAssetsLocationData(response, this.assetList),
        ];
        var posData = "";
        var imei = "";
        var protocolClass = "";
        var deviceInfo = "";
        
         if (!update) {
          for (var i = response.length - 1; i >= 0; i--) {

            posData = response[i];
             imei = posData[1];
           
            protocolClass = posData[2].replace(/\s/g, "");
            deviceInfo = listObj[imei];
           



             if (
              !isObjEmpty(deviceInfo) &&
              deviceInfo.IMEI === imei
            ) {
              this.POSINFOASSETLIST[imei] = Protocol.ClassManager.get(
                protocolClass,
                deviceInfo
              );
              this.POSINFOASSETLIST[imei].initPosInfo(posData);
               
             }
          }
        } else {
          for (let i = data.length - 1; i >= 0; i--) {
            posData = data[i];
            imei = posData[1];

            if (
              (isObjEmpty(this.POSINFOASSETLIST[imei]) &&
                !this.POSINFOASSETLIST[imei].posInfo.positionTime) ||
              (isObjEmpty(this.POSINFOASSETLIST[imei]) &&
                posData[5] >= this.POSINFOASSETLIST[imei].posInfo.positionTime._i)
            ) {
              this.POSINFOASSETLIST[imei].initPosInfo(posData);
              //self.utils.nextFrame(()=>{
              self.methods.updateMarker(imei);
              self.methods.updateAssetListStat(imei);
              if (self.data.BottomWidgetAssetImei === imei) {
                self.emit("bottomWidgetShowAssetDetails", imei);
              }
              //});
            }
            
          }

          console.log('POSINFOASSETLIST',this.POSINFOASSETLIST)
          self.emit("assetPosInfoUpdateReceived", this.POSINFOASSETLIST);
        }
      }
      
 
      let formatAssetList = this.assetList.map(async (asset) => {
        let assetAddress = "";


        let positionAsset = this.posInfoAssets.find(
          (itm) => itm.imei === asset.IMEI
        );
        //console.log('positionAsset', positionAsset)

        if(positionAsset) {
          let assetAddressPromise = this.getAddress({
            Lat: positionAsset.lat,
            Lng: positionAsset.lng,
          });
          await assetAddressPromise.then((data) => {
          assetAddress = data;
        });

        }
        

       
        let obj = {
          ...asset,
          Address: assetAddress,
        };

        return obj;
      });
 
 
      await Promise.all(formatAssetList)
        .then((values) => {
          this.assetList = values;
         })
        .catch((error) => {
          console.error("Error in Promise.all:", error);
        });
    },

    getAssetImg_: function (params, imgFor) {
      var assetImg = "";
      var pattern = /^IMEI_/i;
      var pattern2 = "ic_";
      var regex = /_/gi;
      var regex2 = /\.[^/.]+$/; //remnove extension (.png, .jpg etc)
      var splitted = "";

      if (params && imgFor.assetList) {
        if (params.Icon && pattern.test(params.Icon)) {
          assetImg =
            '<img v-html class="item_asset_img bg-color-grey " src="https://upload.quiktrak.co/Attachment/images/' +
            params.Icon +
            "?" +
            new Date().getTime() +
            'alt="">';
        } else if (params.Icon && params.Icon.substring(0, 3) == pattern2) {
          assetImg =
            '<div class="item_asset_img bg-color-green"><div class="text-align-center vertical-center size-28 "><i class="icon text-color-white asset-icon-' +
            params.Icon.replace(regex, "-").replace(regex2, "") +
            '"></i></div></div>';
        } else if (params.Name) {
          params.Name = $.trim(params.Name);
          splitted = params.Name.split(" ");
          if (splitted.length > 1) {
            var one = "";
            var two = "";
            for (var i = 0; i < splitted.length; i++) {
              if (splitted[i] && splitted[i][0]) {
                if (!one || !two) {
                  if (!one) {
                    one = splitted[i][0];
                  } else {
                    two = splitted[i][0];
                    break;
                  }
                }
              }
            }
            assetImg =
              '<div class="item_asset_img  bg-color-green "><div class="text-align-center vertical-center size-18 text-color-white">' +
              one +
              two +
              "</div></div>";
          } else {
            assetImg =
              '<div class="item_asset_img  bg-color-green "><div class="text-align-center vertical-center size-18 text-color-white">' +
              params.Name[0] +
              params.Name[1] +
              "</div></div>";
          }
        } else if (params.IMEI) {
          assetImg =
            '<div class="item_asset_img bg-color-grey"><div class="text-align-center vertical-center size-18 text-color-white">' +
            params.IMEI[0] +
            params.IMEI[1] +
            "</div></div>";
        }
      } else if (params && imgFor.assetEdit) {
        if (params.Icon && pattern.test(params.Icon)) {
          assetImg =
            '<div class="top-asset-img   vertical-center"> <img class="item_asset_img  bg-color-green" data-name="' +
            params.Icon +
            '" src="https://upload.quiktrak.co/Attachment/images/' +
            params.Icon +
            "?" +
            new Date().getTime() +
            '" alt=""></div>';
        } else if (params.Icon && params.Icon.substring(0, 3) == pattern2) {
          assetImg =
            '<div class="top-asset-img  vertical-center  ><div class="item_asset_img bg-color-grey  text-align-center"><i class="icon size-75 text-color-white asset-icon-' +
            params.Icon.replace(regex, "-").replace(regex2, "") +
            '"></i></div></div>';
        } else {
          assetImg = false;
        }
      } else {
        assetImg = false;
      }
      //console.log(assetImg);
      return assetImg;
    },
    async getAddress(coords) {
      let response = await this.$store.dispatch("GET_ADDRESS_BY_COORDS", {
        latitude: coords.Lat,
        longitude: coords.Lng,
      });
      if (!response) {
        return;
      }
      return response.display_name;
    },
    profileMenu(event) {
      this.$refs.profileMenu.toggle(event);
    },

    assetMenu(event, asset) {
       this.selectedAsset = asset; 
      this.$refs.assetMenu.toggle(event);
    },
    tileMenu(event) {
      this.$refs.tileMenu.toggle(event);
    },
    settingsMenu(event) {
      this.$refs.settingsMenu.toggle(event);
    },
    async onLogin(params) {
      this.getPlusInfo();


      this.isLoading = true;


      var data = {
        account: this.loginForm.username,
        password: this.loginForm.password,
        appKey: "oiltank.quikloc8.com", //localStorage.PUSH_APP_KEY,
        mobileToken: localStorage.PUSH_MOBILE_TOKEN,
        deviceToken: localStorage.PUSH_DEVICE_TOKEN,
        deviceType: "browser", //localStorage.DEVICE_TYPE,
      };

      let result = await this.$store.dispatch("LOGIN", data);
      let userInfo = result.Data;
     

      this.setAssetList({ list: result.Data.AssetArray });

      let assetListObj = await this.$store.dispatch(
        "getFromLocalStorage",
        "assetList"
      );

      console.log("assetListObj", assetListObj);

      this.getAssetListPosInfo(assetListObj);

      let obj = Object.values(assetListObj);

      if (!obj.length) {
        this.isLoading = false;
        this.showLogin = true;
        return;
      }

      this.assetList = obj.map((val) => {
        val.Icon = this.getAssetImg(val, { assetList: true });
        return val;
      });

      let assets = this.assetList;

      setInStorage({
        name: "userInfo",
        data: userInfo,
      });

      setInStorage({
        name: "assetList",
        data: assets,
      });

      console.log('result', result)

     

      console.log('this.showLogin', this.showLogin)
     
      this.showLogin = false;

      setTimeout(() => {
        if(result.MajorToken !== "000") {
        this.isLoading = false;
        return
      }
        this.isLoading = false;
        window.location.reload();
      }, 20000);
     

    },
  },
};
</script>
